import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PublicService {

  private publicConfigSubject = new BehaviorSubject<any | null>(null);
  public public_config$: Observable<any | null> = this.publicConfigSubject.asObservable();

  setPublicData(organization: any) {
  this.publicConfigSubject.next(organization);
  }
  getPublicData(): any | null {
    return this.publicConfigSubject.getValue();
  }
}
